export default {"src":"/_next/static/media/pasta.bf629a9c.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};